// extracted by mini-css-extract-plugin
export default {"p_tye":"cc331cb93f","slcted":"_58883a0321","slc_color":"_70c4ceaef5","item_p":"e02fce2105","r0":"b10147393e"};